import { useContext, useState, useEffect } from 'react'
import { useLocation } from 'react-router'

import { MARKET_TAB } from '../../constants'
import type { MARKET_TAB_TYPE } from '../../constants'

import { StoresContext } from '../../provider/StoreProvider'

import { Head } from '../../components/head/Head'
import { Wrap } from '../../components/container/Wrap'
import { Header } from '../../components/header'
import { Tab } from '../../components/tab'
import { ProductSales } from './ProductSales'
import { ProductSellHistory } from './ProductSellHistory'

const HEAD_INFO = {
  title: '청약 중인 미술품 보기 | 미술품 조각투자 플랫폼',
  description: '지금 청약 진행 중인 블루칩 작가의 미술품을 확인해 보세요. 1만 원부터 시작',
  ogTitle: '청약 중인 미술품 보기 | 미술품 조각투자 플랫폼',
  ogDescription: '지금 청약 진행 중인 블루칩 작가의 미술품을 확인해 보세요. 1만 원부터 시작',
  ogUrl: window.location.href,
}

export function Market() {
  const {
    commonStore: { setShowTab, setActiveTab },
  } = useContext(StoresContext)

  const [listType, setListType] = useState<MARKET_TAB_TYPE>(MARKET_TAB.SALE)

  const location = useLocation()

  useEffect(() => {
    setShowTab(true)
    setActiveTab('market')
    setListType(MARKET_TAB.SALE)
  }, [])

  // page history 관리를 위한 스토리지 저장
  useEffect(() => {
    if (location.state && location.state?.listType) {
      setListType(location.state.listType as MARKET_TAB_TYPE)
    }
  }, [location])

  const onSegmentChange = (value: MARKET_TAB_TYPE) => {
    setListType(MARKET_TAB[value])
  }

  return (
    <>
      <Head {...HEAD_INFO} />
      <Wrap>
        <Header type="SUB" title="청약" isBack={false} />
        <Tab<MARKET_TAB_TYPE>
          items={[
            { text: '작품 목록', value: 'SALE' },
            { text: '이전 매각', value: 'SALE_OFF' },
          ]}
          activeIndex={Object.keys(MARKET_TAB).indexOf(listType)}
          onChange={onSegmentChange}
        />
        {listType === MARKET_TAB.SALE && <ProductSales />}
        {listType === MARKET_TAB.SALE_OFF && <ProductSellHistory />}
      </Wrap>
    </>
  )
}
